module.exports = __webpack_public_path__ + "static/media/daewoo-go-drive.bed1e508.png";